import TButton from './button.vue'
import TButtonGroup from './button-group.vue'
TButton.install = Vue => {
  Vue.component(TButton.name, TButton)
}

TButtonGroup.install = Vue => {
  Vue.component(TButtonGroup.name, TButtonGroup)
}
export {
  TButton,
  TButtonGroup
}



// WEBPACK FOOTER //
// ./src/module/button/index.js